
// Base URLs
export const BASE_URL = process.env.REACT_APP_CALL_API_URL;
export const SOCKET_URL = process.env.REACT_APP_SOCKET;

// API Endpoints
export const API_ENDPOINTS = {
  GET_TOKEN: '/auth/get-token',
  FLIGHT_SEARCH: '/v1/tim-chuyen',
  AIRPORT_SEARCH: '/v1/san-bay/tim-kiem',
  AIRPORT_LIST: '/v1/san-bay',
  SUPPORT_SERVICES: '/v1/danh-sach-phu-tro',
  COUNTRIES: '/v1/quoc-gia',
  CALCULATE_FARE: '/v1/tinh-phi-ve',
  BOOK_FLIGHT: '/v1/dat-chuyen',
};
